import Vue from "vue";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { TooltipModuleState } from "./interfaces";
import { 
  welcomeTooltipsConfig, 
  dashboardTooltipsConfig, 
  candidateTooltipsConfig, 
  postJobTooltipsConfig,
  jobListingTooltipsConfig,
  jobDetailsTooltipsConfig
} from "@/utils/tooltip-configs";

export function createTooltipModule(): any {
  return {
    namespaced: true,
    state: (): TooltipModuleState => ({
      tooltips: {
        active: false,
        currentTooltipId: null,
        currentStep: 0,
        showGuidance: true,
        completedTooltips: []
      },
      availableConfigs: [
        welcomeTooltipsConfig,
        dashboardTooltipsConfig,
        candidateTooltipsConfig,
        postJobTooltipsConfig,
        jobListingTooltipsConfig,
        jobDetailsTooltipsConfig
      ],
      userPreferences: {
        firstRun: true,
        completedTours: [],
        dismissedTooltips: []
      }
    }),
    mutations,
    actions,
    getters
  };
}

export default createTooltipModule();
